import {
    SET_ADD_ACCOUNT_TEXT,
    SET_ADD_ACCOUNT_TOOLTIP_TEXT,
    SET_PLAY_TEXT,
    SET_PLAY_TOOLTIP_TEXT,
    SET_PIN_TOOLTIP_TEXT,
    SET_UNPIN_TOOLTIP_TEXT,
    SET_START_CLIENT_TOOLTIP_TEXT,
    SET_STOP_CLIENT_TOOLTIP_TEXT,
    SET_PROFILE_TOOLTIP_TEXT,
    SET_LOGOUT_TOOLTIP_TEXT,
    SET_ERROR_AUTO_REFRESH_TEXT,
    SET_ERROR_REFRESHING_TEXT,
    SET_TEXTS,
} from './constants'

const initialState = {
    addAccount: '',
    addAccountTooltip: '',
    play: '',
    playTooltip: '',
    pinTooltip: '',
    unPinTooltip: '',
    startTooltip: '',
    stopTooltip: '',
    profileTooltip: '',
    logOutTooltip: '',
    errorAutoRefresh: '',
    errorRefreshing: '',
}

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case SET_ADD_ACCOUNT_TEXT: {
            return {
                ...state,
                addAccount: action.payload,
            }
        }

        case SET_ADD_ACCOUNT_TOOLTIP_TEXT: {
            return {
                ...state,
                addAccountTooltip: action.payload,
            }
        }

        case SET_PLAY_TEXT: {
            return {
                ...state,
                play: action.payload,
            }
        }

        case SET_PLAY_TOOLTIP_TEXT: {
            return {
                ...state,
                playTooltip: action.payload,
            }
        }

        case SET_PIN_TOOLTIP_TEXT: {
            return {
                ...state,
                pinTooltip: action.payload,
            }
        }

        case SET_UNPIN_TOOLTIP_TEXT: {
            return {
                ...state,
                unPinTooltip: action.payload,
            }
        }

        case SET_START_CLIENT_TOOLTIP_TEXT: {
            return {
                ...state,
                startTooltip: action.payload,
            }
        }

        case SET_STOP_CLIENT_TOOLTIP_TEXT: {
            return {
                ...state,
                stopTooltip: action.payload,
            }
        }

        case SET_PROFILE_TOOLTIP_TEXT: {
            return {
                ...state,
                profileTooltip: action.payload,
            }
        }

        case SET_LOGOUT_TOOLTIP_TEXT: {
            return {
                ...state,
                logOutTooltip: action.payload,
            }
        }

        case SET_ERROR_AUTO_REFRESH_TEXT: {
            return {
                ...state,
                errorAutoRefresh: action.payload,
            }
        }

        case SET_ERROR_REFRESHING_TEXT: {
            return {
                ...state,
                errorRefreshing: action.payload,
            }
        }

        case SET_TEXTS: {
            return action.payload
        }

        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/features/Users/data/texts/reducer.js